import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Chip, CircularProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import { commonInputStyle } from '../CustomFormsComponents/CustomField';

export default function AutocompleteConChips(props: any) {
    const {
        value: propValue,
        setValue: propSetValue,
        options = [],
        width = false,
        label,
        placeholder,
        size = 'medium',
        name = '',
        loading,
        required = false,
        templateLabel,
        readOnly = false,
        disabled = false,
        clearPreviousSelection = false,
        allowMultipleSelection = true,
        isOptionIncompatible = () => false,
    } = props;

    const [value, setValue] = useState(propValue);

    useEffect(() => {
        setValue(propValue); 
    }, [propValue]);

    const handleOnChange = (event: any, newValue: any) => {
        if (clearPreviousSelection) {
                if (newValue && newValue.length > 1) {
                newValue = [newValue[newValue.length - 1]];
            }
        }
        propSetValue(newValue || []);
    };

    return (
        <Autocomplete
            multiple={allowMultipleSelection}
            loading={loading}
            size={size}
            id="multiple-limit-tags"
            value={value}
            onChange={handleOnChange}
            noOptionsText="Sin opciones"
            options={options}
            disabled={disabled}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            getOptionLabel={(option: any) => {
                return templateLabel ? templateLabel(option) : option?.nombre;
            }}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip
                        size={size}
                        label={templateLabel ? templateLabel(option) : option?.nombre}
                        color={isOptionIncompatible(option) ? 'warning' : 'default'}
                        {...getTagProps({ index })}
                        key={index}
                    />
                ))
            }
            readOnly={readOnly}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    name={name}
                    placeholder={placeholder}
                    required={required}
                    InputProps={{
                        ...params.InputProps,
                        required: required && value?.length === 0,
                        onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                e.stopPropagation();
                            }
                        },
                        endAdornment: (
                            <>{loading ? <CircularProgress color="inherit" size={20} /> : null}</>
                        )
                    }}
                />
            )}
            sx={{
                width: { width },
                ...commonInputStyle,
                '& .MuiInputLabel-root': {
                    color: '#476773',
                    fontSize: '1rem',
                    top: allowMultipleSelection && value?.length > 0 ? 5 : 10,
                    left: allowMultipleSelection && value?.length > 0 ? 1 : 2,
                    fontWeight: 400
                },
                '& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled': {
                    transform: 'translate(1.2rem, -0.3rem) scale(0.75)'
                }
            }}
        />
    );
}
